import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/index.js';

const {
  shape,
  string,
  bool
} = PropTypes;
function CredentialRegistrationButton({
  credential,
  labels
}) {
  const clickHandler = () => {};
  if (!credential.registered) {
    return /*#__PURE__*/React.createElement(Button, {
      onClick: clickHandler,
      label: labels.registerNow,
      variant: "neutral"
    });
  }
  return null;
}
CredentialRegistrationButton.propTypes = {
  credential: shape({
    registered: bool
  }).isRequired,
  labels: shape({
    registerNow: string
  }).isRequired
};

export { CredentialRegistrationButton as default };
